/* eslint-disable jsx-a11y/anchor-is-valid */
import { Button, Card, Checkbox, Label, TextInput } from "flowbite-react";
import type { FC } from "react";
import { useTranslation } from "react-i18next";

const ForgotPasswordPage: FC = function () {
  const { t } = useTranslation("auth");
  const { t: tCommon } = useTranslation("common");

  return (
    <div className="flex flex-col items-center justify-center px-6 lg:h-screen lg:gap-y-12">
      <a href="/" className="my-6 flex items-center gap-x-1 lg:my-0">
        <img
          alt="Flowbite logo"
          src="https://flowbite.com/docs/images/logo.svg"
          className="mr-3 h-10"
        />
        <span className="self-center whitespace-nowrap text-2xl font-semibold dark:text-white">
          {tCommon("appName")}
        </span>
      </a>
      <Card className="w-full lg:max-w-[640px] lg:[&>*]:w-full lg:[&>*]:p-16">
        <h1 className="text-2xl font-bold dark:text-white md:text-3xl">
          {t("forgot.title")}
        </h1>
        <p className="mb-3 text-gray-500 dark:text-gray-300">
          {t("forgot.description")}
        </p>
        <form>
          <div className="mb-6 flex flex-col gap-y-3">
            <Label htmlFor="email">{tCommon("form.email")}</Label>
            <TextInput
              id="email"
              name="email"
              placeholder={tCommon("form.emailPlaceholder")}
              type="email"
            />
          </div>
          <div className="mb-6 flex items-center gap-x-3">
            <Checkbox id="acceptTerms" name="acceptTerms" />
            <Label htmlFor="acceptTerms">
              {tCommon("form.accept")}&nbsp;
              <a href="#" className="text-primary-700 dark:text-primary-300">
                {tCommon("form.termsAndConditions")}
              </a>
            </Label>
          </div>
          <div>
            <Button type="submit" className="w-full lg:w-auto">
              {t("forgot.submitButton")}
            </Button>
          </div>
        </form>
      </Card>
    </div>
  );
};

export default ForgotPasswordPage;
